import type { TCountry } from "../types";

type TReturnType = { defaultCountry: TCountry | null; otherCountries: TCountry[] };

const splitCountriesToDefaultAndOther = (countries: TCountry[]): TReturnType =>
  countries.reduce<TReturnType>(
    ({ defaultCountry, otherCountries }, country) => {
      if (country.isDefault) {
        return { defaultCountry: country, otherCountries };
      }
      return { defaultCountry, otherCountries: [...otherCountries, country] };
    },
    { defaultCountry: null, otherCountries: [] }
  );
export default splitCountriesToDefaultAndOther;
